import React, { useState, useEffect, useRef } from 'react';
import { RouteComponentProps } from 'react-router-dom'
import * as _usr_const from '../../config/usr-constant';
import * as _view_action from '../../helper/viewAction';
import * as _filter from '../../helper/filter';
import * as _debug from '../../helper/debug';
import axios from 'axios';
import Paper from '@material-ui/core/Paper';
import Loading from '../../components/View/Loading';
import HeadButtonGroups, { HeadButtonGroupBtnActionsProps } from '../../components/View/HeadButtonGroups';
import ZshLogs from '../../components/View/ZshLogs';
import ErrorView from '../../components/View/ErrorView';
import DataTable from '../../components/View/DataTable';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

type AttributeGroupDataProps = {
  id: number;
  common_parent_id: number;
  name: string;
  memo: string;
  common_parent: any;
}

type AttributeGroupConditionProps = {
  name: string;
  operator: string;
  value: string;
  match_conditions: string;
  OR?: AttributeGroupConditionProps[];
}

function AttributeGroupsView({ history, match, location }: RouteComponentProps<{ id: string }>) {

  const unmounted = useRef(false);
  const source = useRef(axios.CancelToken.source());

  const [isInit, setInit] = useState(true);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<AttributeGroupDataProps>({
    id: 0,
    common_parent_id: 0,
    name: '',
    memo: '',
    common_parent: {}
  });
  const [dataMounted, setDataMounted] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [errorStatus, setErrorStatus] = useState(0);
  const [categoryPath, setCategoryPath] = useState([]);
  const [conditions, setConditions] = useState([]);
  const [orConditions, setOrConditions] = useState<AttributeGroupConditionProps[]>([]);

  const handleClickOrConditon = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, condition: AttributeGroupConditionProps) => {
    event.stopPropagation();
    if (condition.OR !== undefined) {
      const orConditions: AttributeGroupConditionProps[] = condition.OR;
      setOrConditions(orConditions);
    }
  }

  const handleDialogClose = () => {
    setOrConditions([]);
  }

  const renderConditions = (conditionsParam: AttributeGroupConditionProps[]) => {
    return (
      <ol className="attribute-group-conditions">
        {
          conditionsParam.length > 0 &&
          conditionsParam.map((condition: AttributeGroupConditionProps, index: number) => (
            <li key={'ag-conditon-' + index}>
              {
                condition.OR === undefined &&
                <div>
                  <span>{condition.name}</span>
                  <span dangerouslySetInnerHTML={{ __html: condition.operator }}></span>
                  <span>{condition.value}</span>
                  <span>{condition.match_conditions}</span>
                </div>
              }
              {
                condition.OR !== undefined &&
                <span
                className="trim a-span"
                onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => handleClickOrConditon(event, condition)}
                >
                  {
                    condition.OR.map((or: AttributeGroupConditionProps, orIndex: number) => (
                      <span key={'ag-or-conditon-' + index + '-' + orIndex}>
                        <span>{or.name}</span>
                        <span dangerouslySetInnerHTML={{ __html: or.operator }}></span>
                        <span>{or.value}</span>
                      </span>
                    ))
                  }
                </span>
              }
            </li>
          ))
        }
      </ol>
    );
  }

  const clickCustomerCell = (callbackParams: any) => {
    history.push('/customers/' + callbackParams.data.id);
  }

  const clickMailMagazineCell = (callbackParams: any) => {
    history.push('/mail-magazines/' + callbackParams.data.id);
  }

  const showMailMagazineTbodyRow = (params: any) => {
    return (
      <div className="data-table-inline-content">
        <div className="data-table-inline-content-text">
          <div className="in-content">{_filter.ShFilter(params.data.send_date, 'YMDHms')}</div>
          <div className="in-content">{params.data.subject}</div>
          <div className="in-content"><span dangerouslySetInnerHTML={{__html: params.data.status_display}}></span></div>
          <div className="in-content">配信数：{_filter.ShFilter(params.data.sent_number, 'number_format')}</div>
        </div>
      </div>
    );
  }

  // clean up
  useEffect(() => {
    const clSource = Object.assign({}, source.current);
    return () => {
      // cancel axios get
      clSource.cancel('cancel attribute groups get');
      unmounted.current = true;
    }
  }, []);

  useEffect(() => {
    if (isInit) {
      setLoading(true);
      _view_action.getViewData<AttributeGroupDataProps>({
        unmounted,
        source,
        dataKey: 'attributeGroup',
        path: _usr_const.ApiUrl + 'attribute-groups/view/' + match.params.id + '/index.json',
        setData,
        setDataMounted,
        setErrorStatus,
        setErrorMsg,
        setLoading,
        successCallbackAftereSetData: (results: any) => {
          if (results.data.category_path !== undefined) {
            setCategoryPath(results.data.category_path);
          }
          if (results.data.conditions !== undefined) {
            setConditions(results.data.conditions);
          }
        }
      })
        .catch((error) => {
          _debug.debugAxiosError(error);
        });
      setInit(false);
    }
  }, [isInit, match.params.id]);

  const btnActions: HeadButtonGroupBtnActionsProps[] = [
    {
      type: 'edit',
      func: (): void => {
        history.push('/attribute-groups/' + match.params.id + '/edit');
      },
      role: {
        name: 'AttributeGroups',
        action: 'edit',
      },
    },
  ];

  return (
    <div id="attribute-groups" className="content-1">
      <Loading loading={loading} />
      {
        dataMounted &&
        <div>
          <HeadButtonGroups
            history={history}
            btnActions={btnActions}
          />
          <Paper>
            <div className="view-content-in">
              <table className="table-1">
                <tbody>
                  <tr>
                    <th>カテゴリ</th>
                    <td>
                      {
                        categoryPath.length > 0 &&
                        <div dangerouslySetInnerHTML={{ __html: categoryPath.join(' &gt; <br />') }}></div>
                      }
                    </td>
                  </tr>
                  <tr>
                    <th>グループ名称</th>
                    <td>{data.name}</td>
                  </tr>
                  <tr>
                    <th>メモ</th>
                    <td>{data.memo}</td>
                  </tr>
                  <tr>
                    <th>条件</th>
                    <td>
                      {renderConditions(conditions)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Paper>
          <Paper className="content-2">
              <DataTable
                rows={_usr_const.customerRows}
                checkbox={false}
                dataKey='customers'
                jsonPath={`customers/previewAttributeGroup/${match.params.id}/index.json`}
                urlQuery={false}
                limit={5}
                size="small"
                parentProps={{ history, location }}
                handleClickCell={clickCustomerCell}
                defaultQueryValues={
                  {
                    attribute_group_id: match.params.id
                  }
                }
              />
          </Paper>
          <Paper className="content-2">
            <h2 className="h-2">メール配信履歴</h2>
            <DataTable
              checkbox={false}
              dataKey='mailMagazines'
              jsonPath={'mail-magazines/index/index.json'}
              urlQuery={false}
              handleClickCell={clickMailMagazineCell}
              funcTbodyRow={showMailMagazineTbodyRow}
              limit={5}
              size="small"
              defaultQueryValues={
                {
                  attribute_group_id: match.params.id,
                  status: 'sent'
                }
              }
            />
          </Paper>
          <ZshLogs logs={data.common_parent.logs} />
        </div>
      }
      {
        errorMsg !== '' &&
        <div>
          <ErrorView
            history={history}
            errorStatus={errorStatus}
            errorMsg={errorMsg}
          />
        </div>
      }
      <Dialog
        fullWidth={true}
        open={orConditions.length > 0}
        onClose={handleDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">OR条件</DialogTitle>
        <DialogContent>
          {renderConditions(orConditions)}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="default">
            閉じる
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default AttributeGroupsView;